import { ICurrentApplicationService } from '../data';
import { IRequestService } from '../request.service';

export interface IFilePathsHelper {
    getContentUrl(): string;
}

export class FilePathsHelper implements IFilePathsHelper {

    static serviceId = 'filePathsHelper';
    static $inject = ['currentApplicationService', 'requestService'];

    constructor(
        private _currentApplicationService: ICurrentApplicationService,
        private _requestService: IRequestService
    ) {
    }

    getContentUrl(): string {
        const appConfig = this._currentApplicationService.getApplicationConfiguration();
        return appConfig?.guid
            ? this._requestService.getApiUrl() + 'content/' + appConfig.guid + '/'
            : '';
    }
}